import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<FuiCheckbox @settings={{hash onChange=(changeset-set this.changeset this.key)}} {{!-- @glint-expect-error --}} @label={{@label}} @checked={{changeset-get this.changeset this.key}} {{!-- @glint-expect-error --}} @type={{@type}} />", {
  moduleName: "core/components/formy/checkbox/index.hbs"
});